module.exports = __webpack_public_path__ + "static/media/Nicola Caisley (5).29b30e38.jpg";